export const setConcentration = (concentration) => {
  return {
    type: "SET_DIALYSIS_CONCENTRATION",
    payload: concentration,
  };
};
